const TONES: Record<string, string> = {
  ACTIVE: 'bg-green-100 text-green-800',
  FINISHED: 'bg-slate-200 text-slate-700',
  SCHEDULED: 'bg-amber-100 text-amber-800',
  issued: 'bg-blue-100 text-blue-800',
  redeemed: 'bg-green-100 text-green-800',
  'test account': 'bg-amber-100 text-amber-800',
  'open link': 'bg-violet-100 text-violet-800',
  // Daily wheel spins
  granted: 'bg-green-100 text-green-800',
  failed: 'bg-red-100 text-red-800',
  pending_choice: 'bg-amber-100 text-amber-800',
  declined: 'bg-slate-200 text-slate-700',
  drawn: 'bg-red-100 text-red-800',
  gold: 'bg-yellow-100 text-yellow-800',
  silver: 'bg-slate-200 text-slate-700',
  bronze: 'bg-orange-100 text-orange-800',
  // Player account status and the Tier 1 flag (whales)
  INACTIVE: 'bg-slate-200 text-slate-700',
  SUSPENDED: 'bg-red-100 text-red-800',
  BLOCKED: 'bg-red-100 text-red-800',
  tier1: 'bg-violet-100 text-violet-800',
};

// Event names are the API's; agents read "invited" and "joined".
const LABELS: Record<string, string> = {
  issued: 'invited',
  redeemed: 'joined',
  tier1: 'tier 1',
};

export function Badge({ value }: { value: string | null }) {
  if (!value) return <span className="text-slate-400">–</span>;
  const tone = TONES[value] ?? 'bg-slate-100 text-slate-700';
  return (
    <span className={`inline-block rounded px-2 py-0.5 text-xs font-semibold ${tone}`}>
      {LABELS[value] ?? value.toLowerCase()}
    </span>
  );
}
